import client from '../client';
import type { Review, UpdateReviewInput } from '../../types/review';
import type { ApiResponse, PaginationParams } from '../../types/api';

interface ReviewListParams extends PaginationParams {
  type?: string;
  rating?: number;
  archived?: boolean;
  startDate?: string;
  endDate?: string;
  sort?: 'asc' | 'desc';
}

export const reviewsApi = {
  list: async (storeId: string, params?: ReviewListParams) => {
    const res = await client.get<ApiResponse<{ reviews: Review[]; pagination: { page: number; limit: number; total: number; pages: number } }>>(
      `/dashboard/${storeId}/reviews`,
      { params },
    );
    return res.data.data!;
  },

  get: async (storeId: string, reviewId: string) => {
    const res = await client.get<ApiResponse<{ review: Review }>>(
      `/dashboard/${storeId}/reviews/${reviewId}`,
    );
    return res.data.data!;
  },

  update: async (storeId: string, reviewId: string, data: UpdateReviewInput) => {
    await client.patch(`/dashboard/${storeId}/reviews/${reviewId}`, data);
  },

  archive: async (storeId: string, reviewId: string, archived = true): Promise<void> => {
    await client.post(`/dashboard/${storeId}/reviews/${reviewId}/archive`, { archived });
  },

  delete: async (storeId: string, reviewId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/reviews/${reviewId}`);
  },
};
